<div data-test-id="managed-terms-of-use-html"  [innerHtml]="html$ | async" [ngClass]="{ 'd-none': loading }"></div>

<div data-test-id="managed-terms-of-use-loading"  class="py-5 d-flex justify-content-center align-items-center" *ngIf="loading">
  <mat-spinner data-test-id="managed-terms-of-use-spinner"  diameter="30"></mat-spinner>
</div>
